exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dataTables_filter label {\r\n    margin-right: 0px !important;\n}\r\n", ""]);

// exports
